import React from 'react';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';

/** Shared menu/select caret, matching the Total unit selector. */
export const DropdownIndicator: React.FC<{
  open?: boolean;
  className?: string;
}> = ({ open = false, className }) => (
  <KeyboardArrowDown
    className={className}
    aria-hidden="true"
    style={{
      width: 12,
      height: 12,
      fontSize: 12,
      flexShrink: 0,
      transform: open ? 'rotate(180deg)' : undefined,
    }}
  />
);
